import type { ThemeVariable } from "./types"

export const themeVariables: readonly ThemeVariable[] = [
  // Background colors
  { name: "p100-light", value: "226 64.5% 62.5%", category: "background" },
  { name: "p100", value: "226 64.5% 59.5%", category: "background" },
  { name: "p100-shade", value: "226 64.5% 56.5%", category: "background" },

  { name: "p200-light", value: "227 72.5% 56.5%", category: "background" },
  { name: "p200", value: "227 72.5% 53.5%", category: "background" },
  { name: "p200-shade", value: "227 72.5% 50.5%", category: "background" },

  { name: "p300-light", value: "233 79.17% 36.42%", category: "background" },
  { name: "p300", value: "233 79.17% 31.42%", category: "background" },
  { name: "p300-shade", value: "233 79.17% 26.42%", category: "background" },

  { name: "p400-light", value: "230 89.82% 21.25%", category: "background" },
  { name: "p400", value: "230 89.82% 18.25%", category: "background" },
  { name: "p400-shade", value: "230 89.82% 15.25%", category: "background" },

  { name: "p500", value: "0 0% 4%", category: "background" },

  // Text colors
  { name: "t100-light", value: "0 0% 100%", category: "text" },
  { name: "t100", value: "0 0% 100%", category: "text" },
  { name: "t100-shade", value: "0 0% 98%", category: "text" },

  { name: "t200-light", value: "220 33% 73%", category: "text" },
  { name: "t200", value: "220 54% 76%", category: "text" },
  { name: "t200-shade", value: "220 33% 62%", category: "text" },

  { name: "t300-light", value: "220 25% 60%", category: "text" },
  { name: "t300", value: "220 25% 55%", category: "text" },
  { name: "t300-shade", value: "220 25% 50%", category: "text" },
] as const
